import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isNumber } from 'lodash'

import Button from './Button'

import styles from './TipEntryModal.module.scss'

import { centsToDollars } from '../utils/formatters'
import NumberPad from './NumberPad'
import useNumberPad from '../hooks/useNumberPad'

const DEFAULT_MAX_TIP = 999999

const TipEntryModal = ({ title, initialValue, saveButtonText, errorMessage, maxTipInCents, onSubmit, onClose, className }) => {
  if (!isNumber(maxTipInCents) || maxTipInCents > DEFAULT_MAX_TIP) {
    maxTipInCents = DEFAULT_MAX_TIP
  }
  const classNames = cn(styles.tipEntryModal, className)
  const [
    output,
    onInput,
    rawValue,
    isValid
  ] = useNumberPad(
    initialValue,
    centsToDollars,
    (value) => parseInt(value) <= maxTipInCents && parseInt(value) >= 0,
    6
  )

  const handleUpdateValue = () => {
    onSubmit(parseInt(rawValue, 10))
    onClose()
  }

  let titleElement = null

  if (title) {
    const text = isValid ? title : errorMessage
    titleElement = <h1 className={cn(styles.title, { [styles.error]: !isValid })}>{text}</h1>
  }

  useEffect(() => {
    onSubmit(parseInt(initialValue, 10))
  }, [initialValue])

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.body}>
          <div className={styles.numberPadContainer}>
            {titleElement}
            <div className={styles.numberPadGrid}>
              <div className={cn(styles.displayValue, { [styles.error]: !isValid })}>{output}</div>
              <NumberPad backspace onTapButton={onInput} />
            </div>
          </div>
          <div className={styles.rightSidebar}>
            <Button className={styles.confirmSetValue} disabled={!isValid} onClick={handleUpdateValue}>{saveButtonText}</Button>
            <Button className={styles.cancelButton} onClick={onClose}>Cancel</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

TipEntryModal.defaultProps = {
  title: '',
  errorMessage: '',
  initialValue: 0,
  saveButtonText: 'SAVE',
  validator: () => {},
  onSubmit: () => {},
  onClose: () => {}
}

TipEntryModal.propTypes = {
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  initialValue: PropTypes.number,
  saveButtonText: PropTypes.string,
  validator: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
}

export default TipEntryModal
